import { ActivityTypes } from '../Models/ActivityConstants';
import { FlowNode } from '../Models/GraphModel';

export function isAllowedFlowConnectionScope(source: FlowNode, target: FlowNode, nodes: FlowNode[], allowBlockToolChildConnection = false): boolean {
	const sourceParentId = source.parentId ?? null;
	const targetParentId = target.parentId ?? null;

	if (sourceParentId === targetParentId) {
		return true;
	}

	if (!sourceParentId) {
		return false;
	}

	const sourceBlock = nodes.find((node) => node.id === sourceParentId);
	return sourceBlock !== undefined
		&& (sourceBlock.data.Type !== ActivityTypes.BLOCK_TOOL
			|| (allowBlockToolChildConnection
				&& (target.data.Type === ActivityTypes.BLOCK_TOOL || target.data.Type === ActivityTypes.AGENT_PROGRESS_SINK)))
		&& target.id !== sourceBlock.id
		&& (sourceBlock.parentId ?? null) === targetParentId;
}
